// 编辑模式
export const MODE_TYPE = {
  // 新增
  ADD: 'add',
  // 编辑
  EDIT: 'edit',
  // 复制
  COPY: 'copy',
}
// 编辑模式文案
export const MODE_TYPE_TEXT = {
  [MODE_TYPE.ADD]: '新增',
  [MODE_TYPE.EDIT]: '编辑',
  [MODE_TYPE.COPY]: '新增', // 复制和新增文案一致
}

// 是否有车证
export const DRIVING_LICENSE_OPTIONS = [
  { label: '有车证', value: 1 },
  { label: '无车证', value: 0 },
]

// 上下架状态
export const PLAN_STATUS = {
  ON: 10,
  OFF: 0,
}

// 方案状态筛选项
export const PLAN_STATUS_OPTIONS = [
  { label: '上架', value: 10 },
  { label: '下架', value: 0 },
]

// 关联活动筛选
export const CAMPAIGN_BIND_OPTIONS = [
  { label: '已绑定', value: 1 },
  { label: '未绑定', value: 0 },
]

// 收款方式（纯租/以租代购使用）
export const PAYMENT_METHOD_OPTIONS = [
  { label: '月付(满月)', value: 'MONTH_FULL' },
  { label: '月付(自然月)', value: 'MONTH_NATURAL' },
  { label: '周付(满周)', value: 'WEEK_FULL' },
  { label: '周付(自然周)', value: 'WEEK_NATURAL' },
  { label: '日付', value: 'DAY' },
]

// 结算周期（司机合作使用）
export const SETTLEMENT_CYCLE_OPTIONS = [
  { label: '月结', value: 'MONTH' },
  { label: '周结', value: 'WEEK' },
  { label: '日结', value: 'DAY' },
]
